var AgreementStatus;
(function (AgreementStatus) {
  AgreementStatus["AwaitingApproval"] = "status.awaiting";
  AgreementStatus["Inactive"] = "status.inactive";
  AgreementStatus["Active"] = "status.active";
  AgreementStatus["Pending"] = "status.pending";
  AgreementStatus["Frozen"] = "status.frozen";
  AgreementStatus["New"] = "status.new";
  AgreementStatus["Terminated"] = "status.terminated";
  AgreementStatus["ApprovedAwaitingShipping"] = "status.awaiting_shipping";
  AgreementStatus["Rejected"] = "status.rejected";
  AgreementStatus["Cancelled"] = "status.cancelled";
  AgreementStatus["AwaitngDeactivation"] = "status.awaiting_deactivation";
  AgreementStatus["AwaitingDeactivation"] = "status.awaiting_deactivation";
})(AgreementStatus || (AgreementStatus = {}));
const getAgreementTranslateStatus = input => {
  return AgreementStatus[input] || input;
};
export default getAgreementTranslateStatus;